module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAMCAYAAAA+ht7fAAAAAXNSR0IArs4c6QAAAQtJREFUSA3lljsKwkAQhmdWPIRn8AZKLMQ6grWdj0P56KwFrcUiId4gZ/AQouMO2REkL2arRdMMzP7/x/4bkh0E9xARDkfTJQItbKvv2jkB7rPktENEEq1PDYWPvPkomvWe8DgA0bgyDOK1A915mh7vlestzZD4hk++MSyHsQfBGta2ZCsth8bHQRSvgF6b0k6rGmjWt/S8rVqq64XGN+6brdvvV1+jFaPGo9H68o01yg9KGE1VoxWOxqPRevE58F89HDhXJNZoBavxaLRefMP3rDjbqkYrLI1Ho/XlYzEQxJfaO1jI9i7OkvNEO4CExjccgIcKsIEkW6m6wUMbljmh8T+DRPEmfn+0fAOGEew846t3fAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/more_dot@3x.png
// module id = J1gO
// module chunks = 1